import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[rightResourceLayout]'
})
export class ResourceRightLayoutDirective {

  constructor(public viewContainerRef: ViewContainerRef) {
  }

}
